class TestimonialsSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-testimonials-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-testimonials-dot]'));

    if (!this.slides.length) return;

    this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));

    if (this.currentIndex < 0) {
      this.currentIndex = 0;
    }

    this.autoplay = this.dataset.autoplay === 'true';
    this.interval = Number(this.dataset.interval) || 5000;
    this.pauseOnHover = this.dataset.pauseOnHover === 'true';
    this.timer = null;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.index);

        if (Number.isNaN(index)) return;

        this.goTo(index);
        this.restartAutoplay();
      });
    });

    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    });

    this.goTo(this.currentIndex, false);
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  goTo(index, animate = true) {
    if (!this.slides.length) return;

    if (index < 0) {
      index = this.slides.length - 1;
    }

    if (index >= this.slides.length) {
      index = 0;
    }

    this.currentIndex = index;

    this.slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === this.currentIndex);
    });

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === this.currentIndex;

      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (!animate) {
      this.slides[this.currentIndex].style.animation = 'none';

      requestAnimationFrame(() => {
        this.slides[this.currentIndex].style.animation = '';
      });
    }
  }

  next() {
    this.goTo(this.currentIndex + 1);
  }

  startAutoplay() {
    if (!this.autoplay || this.slides.length <= 1) return;

    this.stopAutoplay();

    this.timer = window.setInterval(() => {
      this.next();
    }, this.interval);
  }

  stopAutoplay() {
    if (!this.timer) return;

    window.clearInterval(this.timer);
    this.timer = null;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

if (!customElements.get('testimonials-slider')) {
  customElements.define('testimonials-slider', TestimonialsSlider);
}